import React from "react";
import SubscriptionPlanCard from "./SubscriptionPlanCard";
import {
    isUpgradePlan,
    SUBSCRIPTION_PLAN_OPTIONS,
} from "./subscriptionPlans";

const SubscriptionPlanGrid = ({
    plans = SUBSCRIPTION_PLAN_OPTIONS,
    currentPlanName,
}) => (
    <section className="mx-auto flex w-full max-w-6xl flex-wrap items-stretch justify-center gap-5">
        {plans.map((plan) => (
            <div
                key={plan.id}
                className="flex w-full max-w-[22.5rem] flex-1 sm:min-w-[18rem]"
            >
                <SubscriptionPlanCard
                    plan={plan}
                    isCurrentPlan={currentPlanName === plan.id}
                    isUpgradeOption={isUpgradePlan(
                        currentPlanName,
                        plan.id,
                    )}
                />
            </div>
        ))}
    </section>
);

export default SubscriptionPlanGrid;
